import React from 'react'
import 'react-vis/dist/style.css'
import {
  RadarChart,
  makeWidthFlexible
} from 'react-vis'

const DATA = [
  { name: 'IN9020', nightvision: 25, megapixel: 2, power: 16, focalmin: 2.8, focalmax: 12, irleds: 6 },
  { name: 'IN4011', nightvision: 15, megapixel: 0.3, power: 10.8, focalmin: 3.7, focalmax: 14.8, irleds: 66 }
]

const FlexibleRadarChart = makeWidthFlexible(RadarChart)

export default class IN8015RadarIN6012 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crosshairValues: []
    };
  }

  render() {
    return (
      <React.Fragment>

        <div className="chart">
          <FlexibleRadarChart
            data={DATA}
            startingAngle={0}
            domains={[
              { name: 'focalmin', domain: [2, 4] },
              { name: 'focalmax', domain: [11, 15] },
              { name: 'megapixel', domain: [0, 2] },
              { name: 'power', domain: [10, 16] },
              { name: 'nightvision', domain: [14, 25] },
              { name: 'irleds', domain: [5, 66] }
            ]}
            margin={{
              left: 50,
              right: 50
            }}
            width={400}
            height={275} />
        </div>

      </React.Fragment>
    );
  }
}